export function initXS2A() {
  window.addEventListener('load', () => {
    const path = window.location.pathname.split('/')[1]
    const fintecSDK = 'https://api.xs2a.com/xs2a.js'
    const fintecCSS = 'https://api.xs2a.com/xs2a.css'
    const fintecCSSRes = 'https://api.xs2a.com/xs2a-responsive.css'

    const script = document.createElement('script')
    script.type = 'text/javascript'

    const link = document.createElement('link')
    link.rel = 'stylesheet'

    const linkRes = document.createElement('link')
    linkRes.rel = 'stylesheet'

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        if (document.querySelector('.xs2a-form-line.xs2a-paragraph.xs2a-none')) {
          if (
            (document?.querySelector('.xs2a-form-line')?.lastChild as HTMLElement)?.innerHTML ===
            'Bitte geben Sie den Kontozugriff in Ihrer Banking App frei, damit Ihr Konto zunächst auf eine ausreichende Deckung überprüft werden kann. '
          ) {
            let paragraph = document?.querySelector('.xs2a-form-line')?.lastChild as HTMLElement
            paragraph.style.display = 'none'

            let p = document.createElement('p')
            p.appendChild(
              document.createTextNode(
                'Bitte geben Sie den Kontozugriff in Ihrer Banking App frei. Wir prüfen zunächst, ob die 0,01 EUR Transaktion möglich ist.'
              )
            )
            let div = document.querySelector('.xs2a-form-line.xs2a-paragraph.xs2a-none')
            div?.appendChild(p)
          }

          if (document.querySelector('.xs2a-checkbox')) {
            let checkboxDiv = document.querySelector('.xs2a-checkbox') as HTMLElement
            if (checkboxDiv && !checkboxDiv.hasAttribute('data-processed')) {
              checkboxDiv.setAttribute('tabindex', '0')
              checkboxDiv.setAttribute('data-processed', 'true')
              let checkboxInput = document.querySelector('.xs2a-checkbox input') as HTMLElement
              checkboxInput.setAttribute('tabindex', '-1')

              checkboxDiv.addEventListener('keydown', (event: KeyboardEvent) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  let checkbox = checkboxDiv.querySelector(
                    '#XS2A-privacy_policy'
                  ) as HTMLInputElement
                  if (checkbox) {
                    checkbox.checked = !checkbox.checked
                  }
                }
              })
            }
          }
        }
      })
    })

    if (path && path.length) {
      if (path === 'micropayment' || path === 'micropayment-fintec') {
        script.src = fintecSDK
        link.href = fintecCSS
        linkRes.href = fintecCSSRes
        document.head.prepend(link)
        document.head.prepend(linkRes)
        document.body.appendChild(script)
        setTimeout(() => {
          const targetNode = document.getElementsByClassName('content-router')[0]
          if (targetNode) {
            observer.observe(targetNode, {
              attributes: true,
              subtree: true,
              childList: true,
            })
          }
        }, 300)
        observer.disconnect()
      }
    }
  })
}
